import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/partner/configurationSEO/filter'; // Importing Filter component
import Settings from 'views/partner/configurationSEO/settings'; // Importing Settings component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PartnerSettingsView class extends JetView to create a specific view for partner settings.
 */
export default class PartnerSettingsView extends JetView {
    /**
     * Configures the UI components of the PartnerSettingsView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            Width: 250, // Width of the left panel
            responsiveCell: false, // Disable responsive behavior for this cell
            css: 'int-left', // CSS class for styling
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Apply the current theme
                    elements: [
                        { view: 'label', label: _('Configuración SEO') }, // Label for SEO configuration
                        {
                            type: 'wide', // Type of the button container
                            cols: [
                                {
                                    view: 'button', // Button to add SEO
                                    id: 'addSEO', // Unique identifier for the button
                                    value: _('Añadir SEO'), // Button label
                                    type: 'form', // Button type
                                    width: 130, // Button width
                                    click: () => {
                                        // Click event handler
                                        $$('AddSEO').show(); // Show the AddSEO component
                                        $$('addform').clearValidation(); // Clear validation on the add form
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Include the Filter component
                Settings, // Include the Settings component
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            view: 'form', // Main view type
            type: 'wide', // Form type
            responsive: true, // Enable responsive behavior
            scroll: true, // Enable scrolling
            rows: [left], // Rows configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.ready(function () {
            // Wait for Webix to be ready
            webix.attachEvent('onRotate', function (orientation) {
                // Attach event for orientation change
                window.location.reload(); // Reload the page on orientation change
            });
        });
    }
}

// FILE DOCUMENTED
